import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { LOGIN_ROUTE } from "../../config/RoutesConstants"
import { 
  Container, 
  Box, 
  Button,
  Collapse,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogTitle,
  Divider,
  IconButton,
  InputLabel,
  Fab,
  FormControl,
  FormControlLabel,
  Grid,
  GridList,
  GridListTile,
  Paper,
  Typography, 
  Tooltip,
  Input,
  Icon,
  Toolbar,
  MenuItem,  
  Select,
  Tab,
  Tabs,
  Table,
  TableRow,
  TableCell,
  TableSortLabel,
  TableHead,
  TableBody,
  TablePagination,
  TextField

} from "@material-ui/core"
import { withTheme } from "@material-ui/core/styles"
import BackIcon from '@material-ui/icons/ArrowBackRounded';
import ArrowRightIcon from '@material-ui/icons/ChevronRight'
import ArrowDownIcon from '@material-ui/icons/ArrowDropDown'
import ArrowUpIcon from '@material-ui/icons/ArrowDropUp'
import Util, { ERROR, SUCCESS, handleSubmitFail } from '../../common/Util'
import Settings from "../../provider/base/Settings"
import { actionGetStatsByEvent } from "../../actions/StatsActions"
import { actionGetPlaces } from "../../actions/PlaceActions"

import moment from "moment"

import SearchIcon from '@material-ui/icons/Search';
// import ClearIcon from '@material-ui/icons/Backspace';
import RefreshIcon from '@material-ui/icons/Sync';
import DetailIcon from '@material-ui/icons/List';

let _handleSubmitFail;
// const stateList = {all:"Todos los estados",pendingUse:"Sin usar",already_used:"Usado"}
class Statistics extends React.PureComponent{
  constructor(props){
    super(props)
    let lastMonth = moment()
    lastMonth = lastMonth.add(-1,"month").format("YYYY-MM-DD")
    let today = moment().format("YYYY-MM-DD")
    let filter = {from:lastMonth, to:today, period:"daily", place:"", state:"", onlyGift:false}
    this.state = {count:0, rowPerPage:10, page:1, orderBy:"evtQt", orderDesc:true, filter:filter, tabIndex:0, openDetail:{}}
    _handleSubmitFail=this.handleSubmitFail.bind(this)
    this.renderTableHeader=this.renderTableHeader.bind(this)
    this.renderTableBody=this.renderTableBody.bind(this)
    this.onRefresh = this.onRefresh.bind(this)
    this.sortStatsByEvent = this.sortStatsByEvent.bind(this)
    this.onFilterDate = this.onFilterDate.bind(this)
    this.onChangePage = this.onChangePage.bind(this)
    this.onChangeRowsPerPage = this.onChangeRowsPerPage.bind(this)
    this.onChangeTab = this.onChangeTab.bind(this)
  }

  componentWillMount(){
    if(!this.props.login){
      this.props.history.replace(LOGIN_ROUTE);      
    }else{
      this.onRefresh()
      this.props.actionGetPlaces(null,this.getPlacesError)
    }
  }

  getStatsByEventError(e){
    console.log("ERROR GET STATS BY Event", e)
    if(!(e&&e.status&&e.status==401))
      Util.showNoty(ERROR, "Ocurrió un error al listar las estadísticas por Evento.")
  }

  getPlacesError(e){
    console.log("ERROR GET Places", e)
    if(!(e&&e.status&&e.status==401))
      Util.showNoty(ERROR, "Ocurrió un error al listar las ubicaciones.")
  }
  
  handleSubmitFail(error){
    console.log("ERROR EN EL SUBMIT", error)
  }

  onRefresh(){
    const {orderBy, orderDesc, filter} = this.state
    let order = {orderBy:orderBy, orderDesc:orderDesc}
    this.props.actionGetStatsByEvent(filter, order, this.onChangePage, this.getStatsByEventError)
  }

  onDetailUser(user){
    
  }

  onSortByField(field){
    if(field == this.state.orderBy){
      this.setState({orderDesc:!this.state.orderDesc}, this.onChangePage)
    }else{
      this.setState({orderBy:field}, this.onChangePage)
    }
  }

  onChangePage(evt=null, newPage=0){
    let from=newPage*this.state.rowPerPage
    let end=from+this.state.rowPerPage
    let users = this.props.statsByEvent //.filter(this.filterUsers)
    
    const count = users.length
    users = users.sort(this.sortStatsByEvent)
    users = users.slice(from, end)
    this.setState({page:newPage, count:count, users:users})
  }

  onChangeRowsPerPage(evt){
    let from=this.state.page*evt.target.value
    let end=from+evt.target.value
    let users = this.props.statsByEvent //.filter(this.filterUsers)
    const count = users.length
    users = users.sort(this.sortStatsByEvent)
    users = users.slice(from, end)
    this.setState({rowPerPage:evt.target.value, users:users})
  }

  sortStatsByEvent(a,b){
    try{
      if(this.state.orderDesc){
        return b[this.state.orderBy] - a[this.state.orderBy]
      }
      return a[this.state.orderBy] - b[this.state.orderBy]
    }catch(e){
      console.log("SORT STATS BY CLIENT ERROR", e)
      return -1
    }
  }

  onChangeFilter(field, evt){
    let filter = {...this.state.filter}  
    console.log("VALUE", evt.target.value)
    filter[field] = field=="onlyGift"?evt.target.checked:evt.target.value
    // if(field=="state"){//Si estoy modificando el estado y seleccioné mas de uno 
    //   if(filter[field].length==0||filter[field][filter[field].length-1]=="all"){//Si deseleccionó todo o seleccionó all
    //     filter[field] = ["all"]
    //   }else{
    //     filter[field] = filter[field].filter((s)=>s!="all")//Quito "Todos los estados" de los seleccionados
    //   }
    // }
    console.log("FILTER", filter)
    this.setState({filter:filter})
  }

  onFilterDate(){
    if(this.state.filter&&this.state.filter.from&&this.state.filter.to){
      this.onRefresh()
    }
  }
  
  onChangeTab(evt, value){
		this.setState({tabIndex:value, page:0}); 
	}

  onOpenDetail(evtId){
    let openDetail = {...this.state.openDetail}
    openDetail[evtId] = openDetail[evtId]?false:true
    this.setState({openDetail:openDetail})
  }

  renderTableHeader(){
    const {theme} = this.props
    const headers = [{id:"evtName",label:"Evento"}, 
                     {id:"tktPlaceName",label:"Ubicación"},
                     {id:"evtQt", label:"Cantidad"},
                     {id:"evtTotal", label:"Total $"},
                     {id:"evtTotalProducer", label:"Total $ Productor"}]
                     
    // if(Settings.IS_USER_VERIFIED){
    //   headers.splice(1,0,{id:"proInstagram",label:"Instagram"})

    // }
    return (
    <TableRow>
      {headers.map((headCell,i)=>{
        if(headCell.id == "tktBuyerDU"||headCell.id == "tktBuyerLastName"){
          return (
            <TableCell> {headCell.label}</TableCell>
          )
        }
        return (
          <TableCell>
            <TableSortLabel
            active={this.state.orderBy === headCell.id}
            direction={this.state.orderBy === headCell.id && this.state.orderDesc ? 'desc' : 'asc'}
            onClick={()=>this.onSortByField(headCell.id)}
            hideSortIcon={true}>
              {headCell.label}
            </TableSortLabel>  
          </TableCell>
        )
      })}
      {/* <TableCell style={theme.table.actionsColumn}>Acciones</TableCell> */}
    </TableRow>
    )
  }

  renderTableBody(){
    const {theme} = this.props
    const { users, openDetail } = this.state

    if(!users||users.length==0){
      return <Box style={theme.table.empty}>No se encontraron registros</Box>
    }
    return users.map((item, index)=>{
      const isOpen = openDetail[item.evtId]
      return (
        [<TableRow style={index%2==0?theme.table.row:theme.table.rowColor}>
          {/* {Settings.IS_USER_VERIFIED&&<TableCell>{item.proInstagram}</TableCell>} */}
          <TableCell>
            <Button startIcon={isOpen?<ArrowUpIcon/>:<ArrowDownIcon/>} onClick={this.onOpenDetail.bind(this, item.evtId)}>{item.evtName}</Button>
          </TableCell>
          <TableCell>{item.evtPlace}</TableCell>
          <TableCell>{item.evtQt}</TableCell>
          <TableCell>{Util.formatCurrency(item.evtTotal)}</TableCell>
          <TableCell>{Util.formatCurrency(item.evtTotalProducer)}</TableCell>
          {/* <TableCell style={theme.table.actionsColumn}>
           
            <Tooltip title="Ver Detalle">
              <IconButton onClick={this.onDetailUser.bind(this, item)}>
                <DetailIcon/>
              </IconButton>
            </Tooltip>
          </TableCell> */}
        </TableRow>,
         <Collapse in={isOpen} timeout="auto" unmountOnExit style={{aligItems:"center"}}>
         <Table stickyHeader style={{marginLeft:20, width:"100%"}}>
             <TableHead > 
               {this.renderTableHeaderDetail()}
             </TableHead>
             <TableBody>
               {this.renderTableBodyDetail(item.tktTypeData)}
             </TableBody>
           </Table> 
       </Collapse>]
      )
    })
  }
  

  renderTableHeaderDetail(){
    const {theme} = this.props
    const headers = [{id:"id",label:"Tipo de Ticket"}, 
                    //  {id:"tktType",label:"Tipo de Ticket"},
                     {id:"Qt", label:"Cantidad"},
                     {id:"Total", label:"Total $"},
                     {id:"TotalProducer", label:"Total $ Productor"}]
                     
    // if(Settings.IS_USER_VERIFIED){
    //   headers.splice(1,0,{id:"proInstagram",label:"Instagram"})

    // }
    return (
    <TableRow>
      {headers.map((headCell,i)=>{
        // if(headCell.id == "evtId"){
          return (
            <TableCell> {headCell.label}</TableCell>
          )
        // }
        // return (
        //   <TableCell>
        //     <TableSortLabel
        //     active={this.state.orderBy === headCell.id}
        //     direction={this.state.orderBy === headCell.id && this.state.orderDesc ? 'desc' : 'asc'}
        //     onClick={()=>this.onSortByField(headCell.id)}
        //     hideSortIcon={true}>
        //       {headCell.label}
        //     </TableSortLabel>  
        //   </TableCell>
        // )
      })}
    </TableRow>
    )
  }
  
  renderTableBodyDetail(detail){
    const {theme} = this.props
    if(!detail||detail.length==0){
      return <Box style={theme.table.empty}>No se encontraron registros</Box>
    }
    return detail.map((item, index)=>{
      return (
        <TableRow style={index%2==0?theme.table.row:theme.table.rowColor}>
          {/* {Settings.IS_USER_VERIFIED&&<TableCell>{item.proInstagram}</TableCell>} */}
          <TableCell>{`${item.tktCategory} - ${item.tktName}`}</TableCell>
          {/* <TableCell>{`${item.ticketType.tktCategory}${item.ticketType.tktDisplayName}`}</TableCell> */}
          <TableCell>{item.Qt}</TableCell>
          <TableCell>{Util.formatCurrency(item.Total)}</TableCell>
          <TableCell>{Util.formatCurrency(item.TotalProducer)}</TableCell>
        </TableRow>
      )
    })
  }

  render(){
    const { theme, handleSubmit, history, placeList} = this.props
    return (
        <Paper style={theme.paper.form}>
          <Toolbar style={{...theme.table.toolbar, justifyContent:"space-between"}} >
            {/* <Box style={{display:"flex",width:"35%", marginBottom:36}}> */}
              <TextField
                  value={this.state.filter.from}
                  label="Fecha desde"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  
                  onChange={this.onChangeFilter.bind(this,"from")}
                />  
                <TextField
                  value={this.state.filter.to}
                  label="Fecha hasta"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  
                  onChange={this.onChangeFilter.bind(this,"to")}
                />  
                <FormControl>
                  <InputLabel id="stateLabel" shrink>Estado</InputLabel>
                  <Select
                    labelId="stateLabel"
                    value={this.state.filter.state}
                    onChange={this.onChangeFilter.bind(this,"state")}
                    displayEmpty
                    // multiple
                    // renderValue={(selected) => (
                    //   <div >
                    //     {selected.map((item) => (
                    //       <Chip key={item} label={stateList[item]} color="primary"/>
                    //     ))}
                    //   </div>
                    // )}
                  >
                    
                    <MenuItem value=""><em>Todos los estados</em></MenuItem>
                    {/* <MenuItem value="pendingCreate"><em>Invitación pendiente de aceptar</em></MenuItem> */}
                    <MenuItem value="pendingUse">Sin usar</MenuItem>
                    <MenuItem value="already_used">Usado</MenuItem>
                    {/*Object.keys(stateList).map((s)=><MenuItem value={s}>{stateList[s]}</MenuItem>)*/}
                  </Select>
                </FormControl>
                <FormControl>
                  <FormControlLabel
                    label="Solo invitaciones"
                    control={
                      <Checkbox
                        color="primary"
                        checked={this.state.filter.onlyGift}
                        onChange={this.onChangeFilter.bind(this,"onlyGift")}
                      />
                    }
                  />
                </FormControl>
                
                <FormControl>
                  <InputLabel id="placeLabel" shrink>Ubicación</InputLabel>
                  <Select
                    labelId="placeLabel"
                    value={this.state.filter.place}
                    onChange={this.onChangeFilter.bind(this,"place")}
                    displayEmpty
                  >
                    <MenuItem value=""><em>Todas las ubicaciones</em></MenuItem>
                    {placeList&&placeList.map((p)=><MenuItem value={p.id}>{p.plcName}</MenuItem>)}
                  </Select>
                </FormControl>
                <IconButton onClick={this.onFilterDate}>
                <SearchIcon/>
              </IconButton>
              {/* <IconButton onClick={this.onClearBirthdateFilter}>
                <ClearIcon/>
              </IconButton> */}
            {/* </Box> */}
          </Toolbar>
          <Table stickyHeader>
            <TableHead > 
              {this.renderTableHeader()}
            </TableHead>
            <TableBody>
              {this.renderTableBody()}
            </TableBody>
          </Table> 
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 100]}
            component="div"
            count={this.state.count}
            rowsPerPage={this.state.rowPerPage}
            page={this.state.page}
            onChangePage={this.onChangePage}
            onChangeRowsPerPage={this.onChangeRowsPerPage}
          />
        </Paper>
    )
  }
}
function mapStateToProps(store) {
  console.log("STORE STATISTICS", store)
  return {
    login: store.auth.login,
    statsByEvent:store.stats.statsByEvent,
    placeList: store.plc.placeList

   
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionGetStatsByEvent,
      actionGetPlaces
    },
    dispatch
  );
}

// Statistics.defaultProps = {
//   stats:{
//     statsTotalQtSell:50,
//     statsTotalQt:1000,
//     statsTotalAmmountProducer:22000,
//     statsTotalAmmount:27000,
//     statsTotalQtSellByRRPP:1100 //transient
//   }
// }

export default withRouter(
    withTheme(
      connect(
        mapStateToProps,
        mapDispatchToProps
      )(Statistics)
    )
  )


// WEBPACK FOOTER //
// ./src/screens/statistics/StatsByEventTab.js